import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { EnvironmentService } from '@surgetech-eu/core'
import { Observable, of } from 'rxjs'
import { PlatingMaterial, PlatingMaterialService } from './services/plating-material.service'

@Injectable()
export class PlatingMaterialsResolver {
    constructor(
        private platingMaterialService: PlatingMaterialService,
        private envService: EnvironmentService
    ) {
        //
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PlatingMaterial[]> {
        const criteria =
            'platingMaterialsCriteria' in route.data
                ? route.data['platingMaterialsCriteria']
                : new Map<string, string[]>([['validationStatus', ['ACCEPTED']]])
        return this.platingMaterialService.getAll(this.envService.get().type, criteria)
    }
}
